import { useEffect } from 'react';
import { useLenis } from 'lenis/react';
import { useCart } from '../lib/CartContext';

// While the cart drawer or a popup is open, freeze the page behind it so
// scrolling the cart doesn't scroll the shop underneath.
const ScrollLock = () => {
  const lenis = useLenis();
  const { isDrawerOpen, pickerTier } = useCart();
  const locked = Boolean(isDrawerOpen || pickerTier);

  useEffect(() => {
    if (!locked) return undefined;
    const prevOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    lenis?.stop();
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
      lenis?.start();
    };
  }, [locked, lenis]);

  return null;
};

export default ScrollLock;
